import { Injectable } from "@angular/core";
import { Observable,  BehaviorSubject } from "rxjs";
import { InfoBoxModel } from "../models/info-box-model";

export type InfoBoxOptions = {
	message: string;
	title?: string;
	displayTimeMs?: number;
};

@Injectable({
	providedIn: "root",
})
export class InfoBoxService {

	private _displayTimeMS: number = 3000;
	private _timerId: any;
	private _messagesSubject = new BehaviorSubject<InfoBoxModel>(
		new InfoBoxModel({ show: false })
	);

	public get messages(): Observable<InfoBoxModel> {
		return this._messagesSubject.asObservable();
	}

	public show({ message, title, displayTimeMs = 3000 }: InfoBoxOptions): void {
		this._displayTimeMS = displayTimeMs;
		this._messagesSubject.next(
			new InfoBoxModel({
				title,
				message,
				show: true,
			})
		);
	}

	public initialized(): void {
		if (this._displayTimeMS > 0) {
			this._timerId = setTimeout(this._hideInfoBox, this._displayTimeMS);
		}
	}

	public hide(): void {
		if (this._timerId) {
			clearTimeout(this._timerId);
		}

		this._hideInfoBox();
	}

	private _hideInfoBox(): void {
		this._messagesSubject.next(
			new InfoBoxModel({
				message: this._messagesSubject.value.message,
				title: this._messagesSubject.value.title,
				show: false,
			})
		);
	};
}
